import { getFunctions, httpsCallable } from 'firebase/functions';
import { getCloudFunctionUrl } from '../../../config/firebaseFunctionUrl';

export async function ensureDesignPrompts(bookId) {
  const functions = getFunctions();
  const fn = httpsCallable(functions, 'ensureDesignPrompts');
  try {
    const res = await fn({ bookId });
    return res?.data || { success: true };
  } catch (e) {
    // Non-blocking; log and continue
    console.error('ensureDesignPrompts error', e);
    return { success: false, error: e?.message || String(e) };
  }
}

export async function ensureDesignPromptsCheck(bookId) {
  const functions = getFunctions();
  const fn = httpsCallable(functions, 'ensureDesignPromptsCheck');
  try {
    const res = await fn({ bookId });
    return res?.data || { success: true, skipped: true };
  } catch (e) {
    console.error('ensureDesignPromptsCheck error', e);
    return { success: false, error: e?.message || String(e) };
  }
}

export async function updateSingleElementPrompt(bookId, spreadId, elementId) {
  try {
    // Use HTTP endpoint with explicit CORS handling
    const response = await fetch(
      getCloudFunctionUrl('updateSingleElementPromptHttp'),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ bookId, spreadId, elementId })
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (e) {
    console.error('updateSingleElementPrompt error', e);
    return { success: false, error: e?.message || String(e) };
  }
}
